<template>
    <div>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="prefix + title">
            <TipoCaracteristicaList @close="select" :prefix="prefix" />
        </b-modal>

        <lg-form-input-finder v-model="localObject" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo Característica deve ser informado!" description="" @handleClean="select">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    components: {
        LgFormInputFinder,
        TipoCaracteristicaList: () => import("@/modules/cadastros/tipo-caracteristica/TipoCaracteristicaList.vue"),
    },

    props: {
        id: String,
        value: Object,
        label: {
            type: String,
            default: 'Tipo Característica:'
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Tipo Característica",
        },

    },

    data() {
        return {
            localObject: this.value,
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue
        },
    },

    methods: {

        async show() {
            await this.$refs.finder.show();
            this.$bvModal.show(this.id);
        },

        async select(item) {
            this.localObject = item;
            this.$emit("close", item);
            this.$refs.finder.hide()
        },
    },
};
</script>
